module.exports = __webpack_public_path__ + "assets/1a575a4138e5f366474f0e7c5bd614a5.woff";